import { useTranslation } from 'react-i18next'

export interface ShowAllAffordanceProps {
  /** Descriptive label shown before the "Show all" link. */
  label: string
  /** Called when the user clicks "Show all". */
  onShowAll: () => void
}

/**
 * EP-97: Presentational affordance for default-filtered list pages.
 * Renders "[label] — [Show all]" to inform the user a filter is active
 * and offer a one-click escape.
 */
export function ShowAllAffordance({ label, onShowAll }: ShowAllAffordanceProps) {
  const { t } = useTranslation('common')

  return (
    <div className="flex items-center gap-2 text-sm text-base-content/70 py-1">
      <span>{label}</span>
      <button
        type="button"
        className="link link-primary text-sm"
        onClick={onShowAll}
      >
        {t('list.show_all')}
      </button>
    </div>
  )
}
